import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Button, Link } from '@material-ui/core';
import clsx from 'clsx';

// STYLES
import { Container } from './styles';

const Banner = props => {
  const {
    className,
    title,
    titleProps,
    subtitle,
    subtitleProps,
    btnText,
    btnProps,
    secondaryBtnText,
    secondaryBtnProps,
    content,
  } = props;

  return (
    <Container className={clsx('banner', className)}>
      <div className="banner__section-left">
        {!!title && (
          <Typography className="banner__title m-b-20" variant="h4" {...titleProps}>
            {title}
          </Typography>
        )}
        {!!subtitle && (
          <Typography className="banner__subtitle m-b-20" variant="body1" {...subtitleProps}>
            {subtitle}
          </Typography>
        )}
        <div className="banner__btns-wrapper">
          {!!btnText && (
            <Button className="banner__btn sizeExtraLarge" color="primary" {...btnProps}>
              {btnText}
            </Button>
          )}
          {!!secondaryBtnText && (
            <Link
              color="inherit"
              className="banner__btn-link"
              component="button"
              {...secondaryBtnProps}
            >
              {secondaryBtnText}
            </Link>
          )}
        </div>
      </div>
      {content && <div className="banner__section-right">{content}</div>}
    </Container>
  );
};

Banner.defaultProps = {
  className: '',
  title: '',
  titleProps: {},
  subtitle: '',
  subtitleProps: {},
  btnText: '',
  btnProps: {},
  secondaryBtnText: '',
  secondaryBtnProps: {},
  content: null,
};

Banner.propTypes = {
  className: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  titleProps: PropTypes.object,
  subtitle: PropTypes.string,
  subtitleProps: PropTypes.object,
  btnText: PropTypes.string,
  btnProps: PropTypes.object,
  secondaryBtnText: PropTypes.string,
  secondaryBtnProps: PropTypes.object,
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.oneOf([null])]),
};

export default React.memo(Banner);
